import React from 'react';
import ReactDOM from 'react-dom';
import { StylesProvider, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';


import { BrowserRouter } from 'react-router-dom';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';

import './index.css';
import App from './App';

import generalReducer from './store/reducers/general';
import authReducer from './store/reducers/auth';
import locationReducer from './store/reducers/location';
import employerReducer from './store/reducers/employer';
import employeeReducer from './store/reducers/employee';
import officeReducer from './store/reducers/office';
import scheduleReducer from './store/reducers/schedule';
import departmentReducer from './store/reducers/department';
import timeClockReducer from './store/reducers/timeClock';
import biReducer from './store/reducers/bi';
import holidayReducer from './store/reducers/holiday';
import vacationReducer from './store/reducers/vacation';
import balanceHoursReducer from './store/reducers/balanceHours';
import staticLocationsReducer from './store/reducers/staticLocations';
import clockInOutReducer from './store/reducers/clockInOut';
import divergenceReducer from './store/reducers/divergence';
import hoursSetsReducer from './store/reducers/hoursSets';
import bankOfHoursReducer from './store/reducers/bankOfHours';
import taskScheduleReducer from './store/reducers/taskSchedule';


/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) ||
  compose;
/* eslint-enable */

const rootReducer = combineReducers({
  general: generalReducer,
  auth: authReducer,
  location: locationReducer,
  data: employerReducer,
  employee: employeeReducer,
  office: officeReducer,
  schedule: scheduleReducer,
  department: departmentReducer,
  timeClock: timeClockReducer,
  bi: biReducer,
  holiday: holidayReducer,
  vacation: vacationReducer,
  balanceHours: balanceHoursReducer,
  staticLocations: staticLocationsReducer,
  clockInOut: clockInOutReducer,
  divergence: divergenceReducer,
  hoursSets: hoursSetsReducer,
  bankOfHours: bankOfHoursReducer,
  taskSchedule: taskScheduleReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Heebo',
      'Sen',
      'Montserrat'
    ].join(',')
  }
})


const app = (
  <Provider store={store}>
    <BrowserRouter>
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StylesProvider>
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
